<template>
  <div class="widget-wrapper h-100 p-3 rounded">
    <div v-if="loading" class="loader h-100 d-flex align-items-center justify-content-center">
      <Spinner />
    </div>
    <div v-else class="widget-inner d-flex flex-column justify-content-between h-100">
      <div class="widget-header d-flex justify-content-between py-2">
        <h6 class="text-primary h5">
          {{ title }}
        </h6>
        <button v-if="canGoFullscreen" class="btn btn-link p-0" type="button" @click.prevent="$refs['fullscreen-dashboard-widget'].show()">
          <i class="fas fa-expand" title="Espandi" />
        </button>
      </div>

      <div class="flex-grow-1 widget-content w-100 container-fluid">
        <slot name="default"></slot>
      </div>
    </div>

    <BModal v-if="canGoFullscreen" :title="title" :dialog-class="dialogClass || 'modal--type-dashboard-widget'" ref="fullscreen-dashboard-widget" hide-footer centered scrollable>
      <slot name="fullscreen"></slot>
    </BModal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
    Spinner: () => import('../../Layout/Spinner'),
  },
  props: {
    canGoFullscreen: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    dialogClass: {
      type: String,
      default: null,
    },
  },
};

</script>

<style lang="scss">

.widget-wrapper {
  box-shadow: 0 3px 6px rgba($black, .13);
  max-height: 275px;
  min-height: 275px;

  &.no-overflow {
    .widget-content {
      overflow: auto;
    }
  }

  select {
    margin-bottom: 1em;
    padding: .25em;
    border: 0;
    border-bottom: 2px solid rgba($primary, .5);
    font-weight: bold;
    letter-spacing: .15em;
    border-radius: 0;

    &:focus, &:active {
      outline: 0;
      border-bottom-color: rgba($primary, .5);
    }
  }
}

.modal--type-dashboard-widget {
  .modal-title {
    color: $primary;
  }
  .table {
    margin: 0 auto;
    max-width: 750px;
  }
}

</style>
